import { useState } from 'react'
import './FAQ.css'

function FAQ() {
    const [show,setShow]=useState('1')
    const [q1,setQ1]=useState(false)
    const [q2,setQ2]=useState(false)
    const [q3,setQ3]=useState(false)
    const [q4,setQ4]=useState(false)
    const [q5,setQ5]=useState(false)
    const [q6,setQ6]=useState(false)
    const [q7,setQ7]=useState(false)
    const [q8,setQ8]=useState(false)
    const [q9,setQ9]=useState(false)
    const [q10,setQ10]=useState(false)
    const [q11,setQ11]=useState(false)
    const [q12,setQ12]=useState(false)
    const [q13,setQ13]=useState(false)
    const [q14,setQ14]=useState(false)
    const [q15,setQ15]=useState(false)
    const [q16,setQ16]=useState(false)
  return (
    <div className='faq'>
        <div className="one">
            <div className="two">
                <div className="content">
                    <div className="title">
                        <h1>Frequently Asked Questions</h1>
                    </div>
                    <div className="list">
                        <div className="menu">
                            <div className="left">
                                <div className="asked">
                                    <ul>
                                        <li onClick={()=>{setShow('1')}} className={show === '1' ? "option active" : "option"}><a href='#7'>All Inquiries </a></li>
                                        <li onClick={()=>{setShow('2')}} className={show === '2' ? "option active" : "option"}><a href='#7'> Reservation Inquiries </a></li>
                                        <li onClick={()=>{setShow('3')}} className={show === '3' ? "option active" : "option"}><a href='#7'>Optional Equipment </a></li>
                                        <li onClick={()=>{setShow('4')}} className={show === '4' ? "option active" : "option"}><a href='#7'> Payment Methods </a></li>
                                        <li onClick={()=>{setShow('5')}} className={show === '5' ? "option active" : "option"}><a href='#7'>Picking up & dropping off </a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="question">
                            <div className="marks">
                                <div className="text">
                                    {
                                        show === '1' ?<>
                                            <div className="right">
                                        <div className="head" onClick={()=>{setQ1(!q1)}} >
                                            <h3>How to book a car?</h3>
                                        </div>
                                        <div className={q1 ? "answer active" : "answer"}>
                                            <p>Once GoLimo receives the payment, we send you the driver and car information, which is considered a confirmation email.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ2(!q2)}}>
                                            <h3>What is the minimum time required to book a car?</h3>
                                        </div>
                                        <div className={q2 ? "answer active" : "answer"}>
                                            <p>In Cairo, a minimum of 3 hours is required before the pickup. If the location is anywhere in Egypt but outside Cairo, a minimum of 12 hours is required.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ3(!q3)}}>
                                            <h3>What document do I need to present when meeting my chauffeur?</h3>
                                        </div>
                                        <div className={q3 ? "answer active" : "answer"}>
                                            <p>GoLimo does not require any documents. However, standard documents such as the national ID or passport will be needed for the regular checkpoints.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ4(!q4)}}>
                                            <h3>What if I did not receive a confirmation email?</h3>
                                        </div>
                                        <div className={q4 ? "answer active" : "answer"}>
                                            <p>Once GoLimo receives the payment, we send you the driver and car information, which is considered a confirmation email.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ5(!q5)}}>
                                            <h3>Are pets allowed?</h3>
                                        </div>
                                        <div className={q5 ? "answer active" : "answer"}>
                                            <p>Yes, GoLimo is a pet-friendly service.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ6(!q6)}}>
                                            <h3>What if I forgot any of my belongings in the car?</h3>
                                        </div>
                                        <div className={q6 ? "answer active" : "answer"}>
                                            <p>If you forgot any of your belongings in the car, we would contact you once they are found and deliver them to you. You can also contact us through our WhatsApp number +2 01111119411, our hotline 19567, or email us at customer.service@go-limo.com.</p>
                                        </div>
                                    </div>
                                    
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ8(!q8)}}>
                                            <h3>Can I change my reservation details?</h3>
                                        </div>
                                        <div className={q8 ? "answer active" : "answer"}>
                                            <p>Yes, you can change your reservation details 3 hours before the pickup time.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ9(!q9)}}>
                                            <h3>How to contact GoLimo customer service?</h3>
                                        </div>
                                        <div className={q9 ? "answer active" : "answer"}>
                                            <p>You can contact GoLimo’s customer service through: <ul>
                                                <li>Our WhatsApp number is <span>01032990092</span></li>
                                                <li>Our customer service email is <span>customer.service@go-limo.com</span></li>
                                                </ul></p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ10(!q10)}}>
                                            <h3>How to cancel my reservation?</h3>
                                        </div>
                                        <div className={q10 ? "answer active" : "answer"}>
                                            <p>To cancel your reservation, you should contact our hotline 19567, or our WhatsApp number: <span>01032990092</span>.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ11(!q11)}}>
                                            <h3>Are the cars trackable?</h3>
                                        </div>
                                        <div className={q11 ? "answer active" : "answer"}>
                                            <p>Yes, all of our GoLimo cars have a GPS option.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ12(!q12)}}>
                                            <h3>What are the payment methods available?</h3>
                                        </div>
                                        <div className={q12 ? "answer active" : "answer"}>
                                            <p>GoLimo only accepts Debit/Credit cards for payments; you can pay online or directly pay the chauffeur.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ13(!q13)}}>
                                            <h3>What currency do you support?</h3>
                                        </div>
                                        <div className={q13 ? "answer active" : "answer"}>
                                            <p>GoLimo supports any currency, and the customer will be charged in EGP.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ7(!q7)}}>
                                            <h3>Are there any extra fees I will need to pay?</h3>
                                        </div>
                                        <div className={q7 ? "answer active" : "answer"}>
                                            <p>There are no extra fees to be paid except for the service fees; however, if any changes occur, fees will be applied accordingly.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ14(!q14)}}>
                                            <h3>Where can I find my car?</h3>
                                        </div>
                                        <div className={q14 ? "answer active" : "answer"}>
                                            <p>Your GoLimo will be waiting at the location and at the time you requested.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ15(!q15)}}>
                                            <h3>What happens if my flight is delayed or canceled?</h3>
                                        </div>
                                        <div className={q15 ? "answer active" : "answer"}>
                                            <p>GoLimo has a 45 minutes FREE waiting policy if your flight is delayed. If the flight is canceled, you should notify us 3 hours before the pickup time, and you will get a full refund. However, if you inform us less than 3 hours before the pickup time, 50% only of the fees will be deducted.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ16(!q16)}}>
                                            <h3>Can I extend the car reservation later than requested?</h3>
                                        </div>
                                        <div className={q16 ? "answer active" : "answer"}>
                                            <p>Upon availability, however, extra fees will be applied.</p>
                                        </div>
                                    </div>
                                        </>:null
                                    }
                                    {
                                        show === '2' ? <>
                                            <div className="right">
                                        <div className="head" onClick={()=>{setQ1(!q1)}} >
                                            <h3>How to book a car?</h3>
                                        </div>
                                        <div className={q1 ? "answer active" : "answer"}>
                                            <p>Once GoLimo receives the payment, we send you the driver and car information, which is considered a confirmation email.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ2(!q2)}}>
                                            <h3>What is the minimum time required to book a car?</h3>
                                        </div>
                                        <div className={q2 ? "answer active" : "answer"}>
                                            <p>In Cairo, a minimum of 3 hours is required before the pickup. If the location is anywhere in Egypt but outside Cairo, a minimum of 12 hours is required.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ3(!q3)}}>
                                            <h3>What document do I need to present when meeting my chauffeur?</h3>
                                        </div>
                                        <div className={q3 ? "answer active" : "answer"}>
                                            <p>GoLimo does not require any documents. However, standard documents such as the national ID or passport will be needed for the regular checkpoints.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ4(!q4)}}>
                                            <h3>What if I did not receive a confirmation email?</h3>
                                        </div>
                                        <div className={q4 ? "answer active" : "answer"}>
                                            <p>Once GoLimo receives the payment, we send you the driver and car information, which is considered a confirmation email.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ5(!q5)}}>
                                            <h3>Are pets allowed?</h3>
                                        </div>
                                        <div className={q5 ? "answer active" : "answer"}>
                                            <p>Yes, GoLimo is a pet-friendly service.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ6(!q6)}}>
                                            <h3>What if I forgot any of my belongings in the car?</h3>
                                        </div>
                                        <div className={q6 ? "answer active" : "answer"}>
                                            <p>If you forgot any of your belongings in the car, we would contact you once they are found and deliver them to you. You can also contact us through our WhatsApp number +2 01111119411, our hotline 19567, or email us at customer.service@go-limo.com.</p>
                                        </div>
                                    </div>
                                    
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ8(!q8)}}>
                                            <h3>Can I change my reservation details?</h3>
                                        </div>
                                        <div className={q8 ? "answer active" : "answer"}>
                                            <p>Yes, you can change your reservation details 3 hours before the pickup time.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ9(!q9)}}>
                                            <h3>How to contact GoLimo customer service?</h3>
                                        </div>
                                        <div className={q9 ? "answer active" : "answer"}>
                                            <p>You can contact GoLimo’s customer service through: <ul>
                                                <li>Our WhatsApp number is <span>01032990092</span></li>
                                                <li>Our customer service email is <span>customer.service@go-limo.com</span></li>
                                                </ul></p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ10(!q10)}}>
                                            <h3>How to cancel my reservation?</h3>
                                        </div>
                                        <div className={q10 ? "answer active" : "answer"}>
                                            <p>To cancel your reservation, you should contact our hotline 19567, or our WhatsApp number: <span>01032990092</span>.</p>
                                        </div>
                                    </div>
                                        </>:null
                                    }
                                    {
                                        show === '3' ? <>
                                            <div className="right">
                                        <div className="head" onClick={()=>{setQ11(!q11)}}>
                                            <h3>Are the cars trackable?</h3>
                                        </div>
                                        <div className={q11 ? "answer active" : "answer"}>
                                            <p>Yes, all of our GoLimo cars have a GPS option.</p>
                                        </div>
                                    </div>
                                        </>:null
                                    }
                                    {
                                        show === '4' ? <>
                                            <div className="right">
                                        <div className="head" onClick={()=>{setQ12(!q12)}}>
                                            <h3>What are the payment methods available?</h3>
                                        </div>
                                        <div className={q12 ? "answer active" : "answer"}>
                                            <p>GoLimo only accepts Debit/Credit cards for payments; you can pay online or directly pay the chauffeur.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ13(!q13)}}>
                                            <h3>What currency do you support?</h3>
                                        </div>
                                        <div className={q13 ? "answer active" : "answer"}>
                                            <p>GoLimo supports any currency, and the customer will be charged in EGP.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ7(!q7)}}>
                                            <h3>Are there any extra fees I will need to pay?</h3>
                                        </div>
                                        <div className={q7 ? "answer active" : "answer"}>
                                            <p>There are no extra fees to be paid except for the service fees; however, if any changes occur, fees will be applied accordingly.</p>
                                        </div>
                                    </div>
                                        </>:null
                                    }
                                    {
                                        show === '5' ? <>
                                           <div className="right">
                                        <div className="head" onClick={()=>{setQ14(!q14)}}>
                                            <h3>Where can I find my car?</h3>
                                        </div>
                                        <div className={q14 ? "answer active" : "answer"}>
                                            <p>Your GoLimo will be waiting at the location and at the time you requested.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ15(!q15)}}>
                                            <h3>What happens if my flight is delayed or canceled?</h3>
                                        </div>
                                        <div className={q15 ? "answer active" : "answer"}>
                                            <p>GoLimo has a 45 minutes FREE waiting policy if your flight is delayed. If the flight is canceled, you should notify us 3 hours before the pickup time, and you will get a full refund. However, if you inform us less than 3 hours before the pickup time, 50% only of the fees will be deducted.</p>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <div className="head" onClick={()=>{setQ16(!q16)}}>
                                            <h3>Can I extend the car reservation later than requested?</h3>
                                        </div>
                                        <div className={q16 ? "answer active" : "answer"}>
                                            <p>Upon availability, however, extra fees will be applied.</p>
                                        </div>
                                    </div>
                                        </>:null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default FAQ